import React from 'react'
import { LanguageProvider } from './src/context/locale-context'

export const wrapRootElement = ({ element }) => {
  return (
    <LanguageProvider>
      {element}
    </LanguageProvider>
  )
}
